module.exports = __webpack_public_path__ + "74bd1af95f5aa121f40fe53fb08344a2.svg";